import { useState } from "react";
import { useParams } from "react-router-dom";
import './css/sale.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import {
    faGasPump,
    faCog,
    faTachometerAlt,
    faPalette,
    faCarSide,
    faFileContract,
    faChair,
    faCar,
    faPaintBrush,
    faRoad,
    faCalendarAlt,
    faIdCard,
    faCalendarPlus,
    faDoorOpen,
} from '@fortawesome/free-solid-svg-icons';
import { getCarById } from '../components/CarData';

type IconKey =
    | 'faGasPump'
    | 'fas fa-cog'
    | 'fas fa-tachometer-alt'
    | 'fas fa-palette'
    | 'fas fa-car-side'
    | 'fas fa-file-contract'
    | 'fas fa-chair'
    | 'fas fa-car'
    | 'fas fa-paint-brush'
    | 'fas fa-road'
    | 'fas fa-calendar-alt'
    | 'fas fa-id-card'
    | 'fas fa-calendar-plus'
    | 'fas fa-door-open';

const iconMap: Record<IconKey, IconDefinition> = {
    faGasPump: faGasPump,
    'fas fa-cog': faCog,
    'fas fa-tachometer-alt': faTachometerAlt,
    'fas fa-palette': faPalette,
    'fas fa-car-side': faCarSide,
    'fas fa-file-contract': faFileContract,
    'fas fa-chair': faChair,
    'fas fa-car': faCar,
    'fas fa-paint-brush': faPaintBrush,
    'fas fa-road': faRoad,
    'fas fa-calendar-alt': faCalendarAlt,
    'fas fa-id-card': faIdCard,
    'fas fa-calendar-plus': faCalendarPlus,
    'fas fa-door-open': faDoorOpen
};

const Sale = () => {
    const { id } = useParams<{ id: string }>();
    const [selectedImage, setSelectedImage] = useState(0);

    const car = id ? getCarById(parseInt(id)) : null;

    if (!car) {
        return <div>Loading...</div>;
    }

    return (
        <div className="mercedes-container">
            <div className="car-listing">
                <div className="car-gallery">
                    <div className="main-image">
                        <img src={car.images[selectedImage] || car.image} alt={car.title} />
                    </div>
                    <div className="thumbnail-container">
                        {car.thumbnails.map((thumb, index) => (
                            <div
                                key={index}
                                className={`thumbnail ${selectedImage === index ? 'active' : ''}`}
                                onClick={() => setSelectedImage(index)}
                            >
                                <img src={thumb} alt={`Thumbnail ${index + 1}`} />
                            </div>
                        ))}
                    </div>
                </div>

                <div className="car-details">
                    <h1 className="car-title">{car.title}</h1>
                    <div className="car-price">{car.price}</div>

                    <div className="specs-grid">
                        {car.specs.map((spec, index) => (
                            <div key={index} className="spec-item">
                                <div className="spec-icon">
                                    <FontAwesomeIcon icon={iconMap[spec.icon as IconKey]} />
                                </div>
                                <div className="spec-content">
                                    <span className="spec-label">{spec.label}</span>
                                    <span className="spec-value">{spec.value}</span>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="description">
                        <h3>Нэмэлт мэдээлэл</h3>
                        {car.description.map((item, index) => (
                            <p key={index}>{item}</p>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Sale;